// extracted by mini-css-extract-plugin
export default {"grid":"FormShipmentInfo_grid__rh0uj"};